var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 15",
    d: "M12.8638 16.5192C12.4779 17.1807 11.5221 17.1807 11.1362 16.5192L5.87726 7.50387C5.48837 6.83721 5.96925 6 6.74104 6L17.259 6C18.0308 6 18.5116 6.83722 18.1227 7.50387L12.8638 16.5192Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.9b5c2706568f789a7d74557d423e14b9.svg";
export { ForwardRef as ReactComponent };